import * as types from '../mutation-types'
import { api } from '@/modules/api'
import { pathOr } from 'ramda'

const state = {
  votingVoters: [],
  votingStepOne: [],
  votingStepTwo: [],
  votingStepOneIndividual: [],
  votingStepTwoIndividual: [],
  stepOneAttendeesCount: 0,
  stepOneVotesCount: 0,
  stepOneAttendeesCountIndividual: 0,
  stepOneVotesCountIndividual: 0,
  stepTwoAttendeesCount: 0,
  stepTwoVotesCount: 0,
  stepTwoAttendeesCountIndividual: 0,
  stepTwoVotesCountIndividual: 0
}

const getters = {
  getVotingVoters: state => state.votingVoters,
  getVotingStepOne: state => state.votingStepOne,
  getVotingStepTwo: state => state.votingStepTwo,
  getVotingStepOneIndividual: state => state.votingStepOneIndividual,
  getVotingStepTwoIndividual: state => state.votingStepTwoIndividual,
  getStepOneAttendeesCount: state => state.stepOneAttendeesCount,
  getStepTwoAttendeesCount: state => state.stepTwoAttendeesCount,
  getStepOneAttendeesCountIndividual: state => state.stepOneAttendeesCountIndividual,
  getStepTwoAttendeesCountIndividual: state => state.stepTwoAttendeesCountIndividual,
  getStepOneVotesCount: state => state.stepOneVotesCount,
  getStepTwoVotesCount: state => state.stepTwoVotesCount,
  getStepOneVotesCountIndividual: state => state.stepOneVotesCountIndividual,
  getStepTwoVotesCountIndividual: state => state.stepTwoVotesCountIndividual
}

const actions = {
  async fetchVotingStepOne ({commit}, name) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsSettings.fetchVotingStepOne(name))
      commit(types.SET_VOTING_STEP_ONE, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards voting one wasn\'t loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVotingStepTwo ({commit}, name) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsSettings.fetchVotingStepTwo(name))
      commit(types.SET_VOTING_STEP_TWO, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards voting one wasn\'t loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVotingStepOneIndividual ({commit}, name) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsSettings.fetchVotingStepOneIndividual(name))
      commit(types.SET_VOTING_STEP_ONE_INDIVIDUAL, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards voting one wasn\'t loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVotingStepTwoIndividual ({commit}, name) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsSettings.fetchVotingStepTwoIndividual(name))
      commit(types.SET_VOTING_STEP_TWO_INDIVIDUAL, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards voting one wasn\'t loaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVotingVoters ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsSettings.fetchVotingVoters())
      commit(types.SET_VOTING_VOTERS, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to load voters')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVotingStatisticsStepOne ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsSettings.fetchStepOneStatistics())
      commit(types.SET_VOTING_STATISTICS_STEP_ONE, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to load voting statistics')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVotingStatisticsStepTwo ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsSettings.fetchStepTwoStatistics())
      commit(types.SET_VOTING_STATISTICS_STEP_TWO, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to load voting statistics')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVotingStatisticsStepOneIndividual ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsSettings.fetchStepOneStatisticsIndividual())
      commit(types.SET_VOTING_STATISTICS_STEP_ONE_INDIVIDUAL, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to load voting statistics')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchVotingStatisticsStepTwoIndividual ({commit}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios.get(api.awardsSettings.fetchStepTwoStatisticsIndividual())
      commit(types.SET_VOTING_STATISTICS_STEP_TWO_INDIVIDUAL, data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to load voting statistics')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putAwardsGeneralSettings ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.awardsSettings.updateGeneralSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards settings wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putAwardsIndividualSettings ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.awardsSettings.updateIndividualSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards individual settings wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putAwardsWelcomeSettings ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.awardsSettings.updateWelcomeSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards welcome settings wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putAwardsSettingsWinners ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.awardsSettings.updateSettingsWinners(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards settings wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putAwardsSettingsIndividualWinners ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.awardsSettings.updateSettingsIndividualWinners(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Awards settings wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putAwardsStepOneSettings ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.awardsSettings.updateStepOneSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      if (pathOr('', ['response', 'data', 'Code'], err) === 'validation.base-0001') {
        commit(types.CREATE_ERROR_MESSAGE, 'Awards step one settings weren\'t uploaded.' + ' ' + pathOr('', ['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err))
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Awards step one settings weren\'t uploaded')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putAwardsStepOneIndividualSettings ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.awardsSettings.updateStepOneIndividualSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      if (pathOr('', ['response', 'data', 'Code'], err) === 'validation.base-0001') {
        commit(types.CREATE_ERROR_MESSAGE, 'Awards step one settings weren\'t uploaded.' + ' ' + pathOr('', ['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err))
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Awards step one settings weren\'t uploaded')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putAwardsStepTwoSettings ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.awardsSettings.updateStepTwoSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      if (pathOr('', ['response', 'data', 'Code'], err) === 'validation.base-0001') {
        commit(types.CREATE_ERROR_MESSAGE, 'Awards step two settings weren\'t uploaded.' + ' ' + pathOr('', ['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err))
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Awards step two settings weren\'t uploaded')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async putAwardsStepTwoIndividualSettings ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.awardsSettings.updateStepTwoIndividualSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Updated!')
    } catch (err) {
      if (pathOr('', ['response', 'data', 'Code'], err) === 'validation.base-0001') {
        commit(types.CREATE_ERROR_MESSAGE, 'Awards step two settings weren\'t uploaded.' + ' ' + pathOr('', ['response', 'data', 'ValidationFailures', '0', 'errorMessage'], err))
      } else {
        commit(types.CREATE_ERROR_MESSAGE, 'Awards step two settings weren\'t uploaded')
      }
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.SET_VOTING_VOTERS] (state, {awardsVoters}) {
    state.votingVoters = awardsVoters
  },
  [types.SET_VOTING_STEP_ONE] (state, {categoryVotes}) {
    state.votingStepOne = categoryVotes
  },
  [types.SET_VOTING_STEP_TWO] (state, { categoryVotes }) {
    state.votingStepTwo = categoryVotes
  },
  [types.SET_VOTING_STEP_ONE_INDIVIDUAL] (state, {categoryVotes}) {
    state.votingStepOneIndividual = categoryVotes
  },
  [types.SET_VOTING_STEP_TWO_INDIVIDUAL] (state, { categoryVotes }) {
    state.votingStepTwoIndividual = categoryVotes
  },
  [types.SET_VOTING_STATISTICS_STEP_ONE] (state, { totalAttendees, totalVotes }) {
    state.stepOneAttendeesCount = totalAttendees
    state.stepOneVotesCount = totalVotes
  },
  [types.SET_VOTING_STATISTICS_STEP_TWO] (state, { totalAttendees, totalVotes }) {
    state.stepTwoAttendeesCount = totalAttendees
    state.stepTwoVotesCount = totalVotes
  },
  [types.SET_VOTING_STATISTICS_STEP_ONE_INDIVIDUAL] (state, { totalAttendees, totalVotes }) {
    state.stepOneAttendeesCountIndividual = totalAttendees
    state.stepOneVotesCountIndividual = totalVotes
  },
  [types.SET_VOTING_STATISTICS_STEP_TWO_INDIVIDUAL] (state, { totalAttendees, totalVotes }) {
    state.stepTwoAttendeesCountIndividual = totalAttendees
    state.stepTwoVotesCountIndividual = totalVotes
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/awards-settings.js